export default "__VITE_ASSET__myOoeTs9__"